import * as React from 'react';
import { useQuery } from 'react-query';
import type {
  ScheduledInvoiceTrackingReport as Report,
} from 'contracts/scheduled-reports';
import { downloadScheduledReport } from 'utils';
import { useFetchScheduledReports } from 'hooks/api/scheduled-reports';
import { Scaffold } from 'layouts';
import {
  TabbedNavigation,
} from 'pages/scheduled-reports/shared-components';
import { DataTableV2 } from 'components/ui/DataTableV2';

import { useInvoiceReportColumns } from './hooks';

export const InvoicesTrackingReportsPage = () => {
  const { fetchScheduledReports } = useFetchScheduledReports<Report>();

  const columns = useInvoiceReportColumns({
    onClickDownload: downloadScheduledReport,
  });

  const reportsQuery = useQuery({
    queryKey: ['fetch-invoice-tracking-reports'],
    initialData: [],
    queryFn: () => fetchScheduledReports({
      type: 'invoices',
    }),
  });

  return (
    <Scaffold>
      <TabbedNavigation />
      <div className={'flex flex-col gap-6'}>
        <DataTableV2
          columns={columns}
          data={reportsQuery?.data ?? []}
        />
      </div>
    </Scaffold>
  );

};